import React, { useState, useContext } from "react";
import DiagramItem from "../DiagramItem/DiagramItem";
import "./DiagramList.css";
import CollapseCommand from "../Commands/CollapseCommand/CollapseCommand";
import useBuildTree from "../../Hooks/useBuildTree.js";
import HorizontalLine from "../Commands/HorizontalLine/HorizontalLine";
import { store } from "../../store.js";

export default function DiagramList(props) {
  const [reduceds, setReduceds] = useState([]);
  const buildTree = useBuildTree();
  var stepColors = [
    { id: -1, color: "#008dff" },
    { id: 999, color: "red" },
  ];
  
 
  const getChildrenSteps = (menu, rightStep, leftStep) => {
    var bottomStep = menu.childs;
    if (bottomStep.length > 1) {
      var endSteps = menu.childs.filter((item) => item.childs.length == 0);

      if (endSteps.length > 0) {
        rightStep.push(endSteps.slice(0, 1)[0]);
        bottomStep = menu.childs.filter(
          (item) => item.step.id != rightStep[0].step.id
        );
      }
      if (endSteps.length > 1) {
        leftStep.push(endSteps.slice(1, 2)[0]);

        bottomStep = bottomStep.filter(
          (item) => item.step.id != leftStep[0].step.id
        );
      }
    }

    return bottomStep;
  };

  const onClickShortCommand = (id) => {
    var newReduceds = [];

    if (reduceds.includes(id))
      newReduceds = reduceds.filter((itemId) => itemId != id);
    else newReduceds = [...reduceds, id];
    setReduceds(newReduceds);
  };

  const showMenu = (menu, firstId, lastId, start = true) => {
    var horizontalLineClass = undefined;

    if (firstId != lastId) {
      if (menu.step.id == firstId) horizontalLineClass = "leftLine";
      else if (menu.step.id == lastId) horizontalLineClass = "rightLine";
      else horizontalLineClass = "middleLine";
    }
    var rightStep = [];
    var leftStep = [];

    var bottomStep = getChildrenSteps(menu, rightStep, leftStep);

    var n = bottomStep.length;
    if (n > 0) {
      firstId = bottomStep[0].step.id;
      lastId = bottomStep[n - 1].step.id;
    }

    const isNodeWithCondition  = (node) => {
      return props.withCondition && isNodeHasChildCondition(node)
    }

    const isNodeHasChildCondition  = (node) => {
      return node.childs.filter(child => child.decision != undefined).length > 0
    }

    return (
      <div className="colDiagram" key={"col" + menu.step.id}>
        {horizontalLineClass && <div className={horizontalLineClass} />}

        <DiagramItem
          key={menu.step.id}
          menuItems={menu}
          rightStep={rightStep}
          leftStep={leftStep}
          rectangleWith="58px"
          rectangleHeight="35px"
          losangeWith="45px"
          losangeHeight="45px"
          verticalLineHeight="10px"
          diagramWidth="auto"
          bottomSteplength={bottomStep.length}
          treeColors={stepColors}
          start={start}
          withCondition={isNodeWithCondition(menu)}
          onClickShortCommand={(itemId) => onClickShortCommand(itemId)}
          reduceds={reduceds}
          shortCommandHeight="8px"
        />

        <div className="tableDiagram" key={"table" + menu.step.id}>
          <div className="rowDiagram" style={{ width: "auto" }}>
            {bottomStep.map((item) => showMenu(item, firstId, lastId, false))}
          </div>
        </div>
      </div>
    );
  };
  
  
  const firstStep = props.diagramItems.data.filter(item => item.order == 1)[0]
  var step = firstStep && { ...firstStep.items.data[0], conditionDescription:firstStep.conditionDescription}
  
  /*var step = {
    id: 1,
    item: { id: 1, item: "Recruitment Requisition" },
    order: 1,
    isChecked: true,
    list: "Steps",
  };*/
  var TreeItem = [];
  //const colors = ["green", "orange", "margenta", "gold", "yellow", "cyan", "olive", "khaki", "pink", "brown",  "grey", "black", "blue"];

  if (step) buildTree(TreeItem, props.diagramItems.data, step, null, reduceds, []);

  var firstId = 1;
  var lastId = 1;
  return TreeItem.map((item) => (
    <div className="tableDiagram" key={"table" + item.step.id}>
      <div className="rowDiagram" style={{ width: "auto" }}>
        {showMenu(item, firstId, lastId)}
      </div>
    </div>
  ));
}
